import { useFlag } from '@wix/da-react-context/pkg/flags/hooks/useFlag';
import React from 'react';
import DesktopProfileTopDisplay728x90Gak from './gak/DesktopProfileTopDisplay728x90';
import DesktopProfileTopDisplay728x90Nitro from './nitro/DesktopProfileTopDisplay728x90';
const DesktopProfileTopDisplay728x90 = ({ safety ='off'  })=>{
    const isDaAds = useFlag('ads_da');
    if (isDaAds) {
        return /*#__PURE__*/ React.createElement(DesktopProfileTopDisplay728x90Gak, {
            safety: safety
        });
    }
    return /*#__PURE__*/ React.createElement(DesktopProfileTopDisplay728x90Nitro, {
        safety: safety
    });
};
DesktopProfileTopDisplay728x90.displayName = 'DesktopProfileTopDisplay728x90';
export default DesktopProfileTopDisplay728x90;
